import { render, staticRenderFns } from "./OrderPlaceField.vue?vue&type=template&id=4a5b7f62&"
import script from "./OrderPlaceField.vue?vue&type=script&lang=js&"
export * from "./OrderPlaceField.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlaceField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports